import api from '../connectors/Api'

const API = api()

export default {
  namespaced: true,
  state: {
    items: {}
  },
  mutations: {
    setItem (state, item) {
      const items = { ...state.items }
      items[item.id] = item
      state.items = items
    }
  },
  getters: {
    get: (state, getters, rootState) => (id) => {
      return state.items[id] || false
    }
  },
  actions: {
    get ({ commit, state, dispatch, getters }, id) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.getAdvertiser(token, id)
            .then((res) => {
              commit('setItem', res.body)
              resolve(getters.get(id))
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    }
  }
}
